import React from "react";
import {
  MessageSquare,
  FileText,
  Activity,
  BarChart3,
  MessageCircle,
  CornerDownRight,
  ThumbsUp,
} from "lucide-react";

interface UserStatsCardsProps {
  user: any;
  stats?: {
    totalPosts?: number;
    totalComments?: number;
    totalReplies?: number; // includes nested
    totalLikes?: number;
    totalChats?: number;
    totalLogins?: number;
    averageSessionDuration?: number;
  };
  onOpenChats?: () => void;
}

const UserStatsCards: React.FC<UserStatsCardsProps> = ({
  user,
  stats,
  onOpenChats,
}) => {
  const statCards = [
    {
      title: "Total Posts",
      value: stats?.totalPosts || 0,
      icon: FileText,
      color: "green",
    },
    {
      title: "Total Comments",
      value: stats?.totalComments || 0,
      icon: MessageCircle,
      color: "purple",
    },
    {
      title: "Total Replies",
      value: stats?.totalReplies || 0,
      icon: CornerDownRight,
      color: "orange",
    },
    {
      title: "Total Likes",
      value: stats?.totalLikes || 0,
      icon: ThumbsUp,
      color: "blue",
    },
    {
      title: "Total Chats",
      value: stats?.totalChats || 0,
      icon: MessageSquare,
      color: "green",
      onClick: onOpenChats,
    },
    {
      title: "Total Logins",
      value: stats?.totalLogins || 0,
      icon: Activity,
      color: "purple",
    },
    {
      title: "Avg Session (min)",
      value: stats?.averageSessionDuration || 0,
      icon: BarChart3,
      color: "orange",
    },
  ];

  const getColorClasses = (color: string) => {
    switch (color) {
      case "blue":
        return {
          bg: "bg-blue-50",
          text: "text-blue-600",
          iconBg: "bg-blue-100",
        };
      case "green":
        return {
          bg: "bg-green-50",
          text: "text-green-600",
          iconBg: "bg-green-100",
        };
      case "purple":
        return {
          bg: "bg-purple-50",
          text: "text-purple-600",
          iconBg: "bg-purple-100",
        };
      case "orange":
        return {
          bg: "bg-orange-50",
          text: "text-orange-600",
          iconBg: "bg-orange-100",
        };
      default:
        return {
          bg: "bg-gray-50",
          text: "text-gray-600",
          iconBg: "bg-gray-100",
        };
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards.map((stat, index) => {
        const IconComponent = stat.icon;
        const colors = getColorClasses(stat.color);

        return (
          <div
            key={index}
            className={`${colors.bg} rounded-lg p-6 border border-gray-200 ${
              (stat as any).onClick ? "cursor-pointer hover:shadow" : ""
            }`}
            onClick={(stat as any).onClick}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 mb-1">
                  {stat.title}
                </p>
                <p className={`text-2xl font-bold ${colors.text}`}>
                  {stat.value.toLocaleString()}
                </p>
              </div>
              <div className={`${colors.iconBg} p-3 rounded-lg`}>
                <IconComponent className={`h-6 w-6 ${colors.text}`} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserStatsCards;
